// Intercept fetch API for Shopify cart requests.

const { fetch: origFetch } = window

window.fetch = async (...args) => {
  const response = await origFetch(...args)

  const url = args[0].toString();

  const clonedResp = response.clone()

  if (url.indexOf('/cart.js') !== -1) {
    const result = await clonedResp.json()
    document.dispatchEvent(new CustomEvent('on:cart:loaded', { detail: { cart: result } }))
  }

  if (url.indexOf('/cart/add.js') !== -1) {
    const result = await clonedResp.json()
    document.dispatchEvent(new CustomEvent('on:cart:add', { detail: { cart: result } }))
  }

  if (url.indexOf('/cart/update.js') !== -1 || url.indexOf('/cart/change.js') !== -1) {
    const result = await clonedResp.json()
    document.dispatchEvent(new CustomEvent('on:cart:update', { detail: { cart: result } }))
  }

  if (url.indexOf('/cart/clear.js') !== -1) {
    const result = await clonedResp.json()
    document.dispatchEvent(new CustomEvent('on:cart:clear', { detail: { cart: result } }))
  }

  return response
}
